import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { readAccessToken } from '@/utils/tokenStorage'

const configUrl = import.meta.env.VITE_API_BASE_URL
const apiBaseUrl = configUrl ? (configUrl + '/api') : '/api'

export const rawBaseQuery = fetchBaseQuery({
  baseUrl: apiBaseUrl,
  credentials: 'include',
  prepareHeaders: (headers) => {
    const token = readAccessToken()
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  },
})
